module.exports = __webpack_public_path__ + "static/media/plusWhite.e27a9ea6.svg";